import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { iif, Observable, of, Subject } from 'rxjs';
import { debounceTime, mergeMap } from 'rxjs/operators';

@Component({
    selector: 'app-autocomplete',
    templateUrl: './autocomplete.component.html',
    styleUrls: ['./autocomplete.component.scss'],
})
export class AutocompleteComponent implements OnInit {
    onInputChange$ = new Subject();
    @Input('loading') loading: boolean = false;
    @Input('result') set r(data) {
        this.result = data;
    }

    result = [];

    @Output('search') search = this.onInputChange$.pipe(debounceTime(300));
    @Output('selected') selected = new EventEmitter();

    constructor() {}

    ngOnInit(): void {}

    onSelectionChange(option) {
        this.selected.emit(option);
    }

    getValueFromObject(option) {
        return option.nome_completo ? option.nome_completo : option;
    }
}
